import PropTypes from 'prop-types';
import {Backdrop, CircularProgress} from "@material-ui/core";
import React from "react";
import styles from './Loading.module.scss';

const Loading = ({loading, addEndListener, backdropClickHandler, overrideClasses, transitionDuration, timeout, icon}) => {

    if (!loading) return null;

    const containerClasses = [styles.container].concat(overrideClasses);

    return (
        <Backdrop
            addEndListener={addEndListener}
            onClick={backdropClickHandler}
            transitionDuration={transitionDuration}
            timeout={timeout}
            open={loading}
            className={containerClasses.join(' ')}>
            {icon}
        </Backdrop>
    );
};

Loading.propTypes = {
    loading: PropTypes.bool,
    addEndListener: PropTypes.func,
    backdropClickHandler: PropTypes.func,
    overrideClasses: PropTypes.array,
    transitionDuration: PropTypes.number,
    timeout: PropTypes.number,
    icon: PropTypes.any,
};

Loading.defaultProps = {
    loading: true,
    addEndListener: () => null,
    backdropClickHandler: () => null,
    overrideClasses: [],
    transitionDuration: 100,
    timeout: 100,
    icon: <CircularProgress color="inherit"/>
};

export default Loading;
